import React, { createContext, useContext, useState, useEffect } from 'react'
import axios from 'axios'
import { imgToBase64, BASE_URL } from '../utils/helpers.util.js'
import { cardTypes } from '../entities/cardType.entity'
import ShopItem from '../entities/shopItem.entity'
import CardPattern from '../entities/cardPattern.entity'
const AppState = createContext()
export const useAppState = () => useContext(AppState)



export default function AppProvider(props) {
  const starterType = cardTypes.get("basic")
  const [state, setState] = useState({
    hideUi: false,
    cardType: starterType,
    cardMaterial: starterType.materials[0],
    cardPatterns: [],
    selectedPattern: null,
    cardColor: starterType.materials[0].colors[0],
    cardText: "",
    cardLogoUrl: null,
    cardLogoBase64: null,
    showLoginModal: false,
    isLoggedIn: false,
    fetchingPatterns: true,
    items: [],
    language: "it",
    localizations: {
      it: {},
      en: {}
    }
  })


  const providerState = {
    state: {
      ...state
    },
    methods: {
      selectCardType: (type = "basic") => {
        const cardType = cardTypes.get(type)
        setState(oldState => ({
          ...oldState,
          cardType: cardType,
          cardMaterial: cardType.materials[0],
          cardColor: cardType.materials[0].colors[0],
          selectedPattern: cardType.defaultPattern
        }))
      },

      selectCardMaterial: (material) => {
        const cardMaterial = state.cardType.materials.find(m => m.name === material)
        setState(oldState => ({
          ...oldState,
          cardMaterial,
          cardColor: cardMaterial.colors[0]
        }))
      },

      selectMaterialColor: (colorName) => {
        const cardColor = state.cardMaterial.colors.find(c => c.name === colorName)
        setState(oldState => ({
          ...oldState,
          cardColor
        })
        )
      },
      setCardLogoUrl(url = null) {
        setState(oldState => ({
          ...oldState,
          cardLogoUrl: url
        }))
      },
      async setCardLogoBase64(file = null) {
        if (file) {
          const data = await imgToBase64(file)
          setState(oldState => ({ ...oldState, cardLogoBase64: data }))
        }
      },
      selectPattern: (name) => {
        const selectedPattern = state.cardPatterns.find(p => p.name == name) || null
        setState(oldState => ({
          ...oldState,
          selectedPattern
        }))
      },
      toggleUi: () => {
        setState(oldState => ({ ...oldState, hideUi: !oldState.hideUi }))
      },

      setCardText: text => {
        if (text.length < 21) {
          setState(oldState => ({
            ...oldState,
            cardText: text
          })
          )
        }

      },
      calculatePrice(item) {
        if (!item) return 0
        let price = item.price
        if (state.cardType.name === "pro") price += item.customizationPrice
        if (state.cardType.name === "one edition") price = 9900
        return price
      },

      getItem() {
        return state.items.find(item => {
          const cardType = state.cardType
          if (cardType.name === "one edition") {
            return item.name === "METAL_ONE"
          } else {
            const material = item.material.indexOf(state.cardMaterial.type) > -1
            const isPvc = item.material === "ps"
            const type = isPvc ? item.material : (
              state.cardColor.name === "Nero" ? "mb" : "ms"
            )
            const color = isPvc ? item.color === state.cardColor.hex : true

            return material && item.material === type && color
          }


        })
      }
    }
  }

  async function fetchShopData() {
    try {
      const { data } = await axios.get(BASE_URL + "/shop/items")
      const patterns = data.items_patterns.map(pattern => new CardPattern({
        id: pattern.id,
        name: pattern.name,
        path: pattern.image_url
      }))

      const items = data.item_types.map(item => new ShopItem(item))
      setState(oldState => ({
        ...oldState,
        cardPatterns: patterns,
        items,
        fetchingPatterns: false,
      }))


    } catch (err) {
      alert("unable to fetch data")
      console.log(err)
    }
  }

  async function initState() {

    const query = window.location.search
    const params = new URLSearchParams(query)

    const cardTypeParam = params.get("type")
    if (cardTypeParam) {
      const cardType = cardTypes.get(cardTypeParam)

      setState(oldState => {
        const state = {
          ...oldState,
          cardType: cardType,
          cardMaterial: cardType.materials[0],
          cardColor: cardType.materials[0].colors[0],
        }

        if (cardTypeParam === "one edition") {
          state.selectedPattern = cardType.defaultPattern
        }


        return state
      }
      )
    }

    await fetchShopData()


  }

  useEffect(() => {
    initState()
  }, [])

  return (
    <AppState.Provider value={providerState}>
      {props.children}
    </AppState.Provider>
  )

}